import { Schema } from 'effect'
import { match } from '@st/pattern'

const CLIENT_PACKETS_FLOW_IDS = ['personalized-checklists', 'personalized-pdf'] as const

export const ClientPacketsFlowIdFromString = Schema.Literals(CLIENT_PACKETS_FLOW_IDS)
export type ClientPacketsFlowId = typeof ClientPacketsFlowIdFromString.Type

type ClientPacketsFlowDefinition = {
  singular: string
  plural: string
  descriptivePlural: string
  titlePlural: string
}

export function clientPacketsFlowDefinition(
  flow: ClientPacketsFlowId
): ClientPacketsFlowDefinition {
  return match(flow)
    .with('personalized-checklists', () => ({
      singular: 'checklist',
      plural: 'checklists',
      descriptivePlural: 'checklists',
      titlePlural: 'Checklists'
    }))
    .with('personalized-pdf', () => ({
      singular: 'organizer PDF',
      plural: 'organizer PDFs',
      descriptivePlural: 'personalized tax organizer PDFs',
      titlePlural: 'Organizer PDFs'
    }))
    .exhaustive()
}
